import { useState, useEffect, useRef, useCallback } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../Lib/contextLib';
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import { API, Auth } from 'aws-amplify';
import PopUp from '../../Popup/logoutPopup';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Module8World.css';
import '../../Animations.css';
import loading from './../../loading-gif-png-5.gif';

import Learn from '../../Learn/Learn';
import Practice from './../../Unit1/Module3/FacialExpressionPractice';
import Day4Practice from './../Day4Practice/Day4Practice';
import SingingTime from '../../SingingTime/SingingTime';
import Celebrate from '../../Celebrate/Celebrate';
import Surprise from '../../SurpriseVideo/surprise';
import FollowTheBeatModule8 from './../../FollowTheBeat/FollowTheBeatModule8.js';
import presentSound from './../../Unit1/Module1/assets/ta_da_gift.mp3';

// Constants
const TIMING = {
  BUTTON_AUDIO_DELAY: 700,
  ANIMATION_DELAY: 500,
  KEY_ANIMATION_DELAY: 1000,
  IOS_VOICE_TIMEOUT: 5000,
  PRIZE_ANIMATION_DELAY: 1000,
  PRIZE_DISPLAY_DELAY: 5000,
};

const COIN_THRESHOLDS = {
  PRIZE_UNLOCK: 100,
  TWO_DIGIT: 10,
  THREE_DIGIT: 100,
};

const STEP_COMPLETED = {
  NOT_STARTED: 'notstarted',
  SINGING_TIME: 'singingtime',
  LEARN: 'learn',
  PRACTICE: 'practice',
  FOLLOW_THE_BEAT: 'followthebeat',
  CELEBRATE: 'celebrate',
  SURPRISE: 'surprise',
};

const MODULE_NAME = 'Ask';
const MODULE_NUM = 'MODULE8';
const SECTION_COMPLETED_THRESHOLD = 4;

const Module8World = () => {
  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const { module8 } = useSelector((state) => state.module8, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  // Audio refs for iOS compatibility
  const coinAudioRef = useRef(null);
  const playLizardCloseRef = useRef(null);
  const checkSoundRef = useRef(null);
  const rewardsFoundRef = useRef(null);
  const touchButtonRef = useRef(null);
  const buttonSoundRef = useRef(null);
  const displayVoiceRef = useRef(null);
  const prizeRef = useRef(null);
  const presentIconRef = useRef(null);

  const background = generateImageUrl('images/Module8Images/Module8NavImages/Background_JourneyMap_Unit2_Mod3.png');
  const animal = generateImageUrl('images/Module3Images/Lizard+closing+still+image.gif');
  const progressbar0 = generateImageUrl('images/Module3Images/LizTongue_Empty_100819.svg');
  const progressbar1 = generateImageUrl('images/Module3Images/LizTongue_1out3_100819.svg');
  const progressbar2 = generateImageUrl('images/Module3Images/LizTongue_2out3_100819.svg');
  const progressbar3 = generateImageUrl('images/Module3Images/LizTongue_2out3_100819.svg');
  const progressbarCompleted = generateImageUrl('images/Module3Images/LizTongue_Complete_100819.svg');
  const coinPick = generateImageUrl('images/Images/AwesomeCoin.png');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const journeyImage = generateImageUrl('images/Module1Images/bluejourneymap.svg');
  const logoutBtn = generateImageUrl('images/Module1Images/Logout.png');
  const reviewBtn = generateImageUrl('images/Module1Images/Button_Review.png');
  const rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png')
  const celebrateBtn = generateImageUrl('images/Module1Images/Button_Celebrate.png');
  const learnBtn = generateImageUrl('images/Module1Images/Button_Learn.png');
  const practiceBtn = generateImageUrl('images/Module1Images/Button_Practice.png');
  const ftbBtn = generateImageUrl('images/Images/Button_FTB.png');
  const fly = generateImageUrl('images/Module3Images/Fly.png');
  const Tree2 = generateImageUrl('images/Module8Images/DailyReward_Tree_2.png');
  const StegoBlue = generateImageUrl('images/Module8Images/DailyReward_Stego_Blue.png');
  const LongNeckGreen = generateImageUrl('images/Module8Images/DailyReward_DinoLongNeck_Green.png');
  const LongNeckRed = generateImageUrl('images/Module8Images/DailyReward_DinoLongNeck_Red.png');
  const RaptorLight = generateImageUrl('images/Module8Images/DailyReward_Raptor_LightBlue.png');
  const StegoGreen = generateImageUrl('images/Module8Images/DailyReward_Stego_Green.png');
  const EggsGreen = generateImageUrl('images/Module8Images/DailyReward_DinoEggs_green.png');
  const DinoFlyingGreen = generateImageUrl('images/Module8Images/DailyReward_DinoFlying_Green.png');
  const RaptorDark = generateImageUrl('images/Module8Images/DailyReward_Raptor_Darker.png');
  const EggsBlue = generateImageUrl('images/Module8Images/DailyReward_DinoEggs_blue.png');
  const DinoOrange = generateImageUrl('images/Module8Images/DailyReward_Dino_Orange.png');
  const DinoGreen = generateImageUrl('images/Module8Images/DailyReward_Dino_Green.png');
  const Plant1 = generateImageUrl('images/Module8Images/DailyReward_Plant1.png');
  const Plant2 = generateImageUrl('images/Module8Images/DailyReward_Plant2.png');
  const Tree1 = generateImageUrl('images/Module8Images/DailyReward_Tree_1.png');
  const DinoFlyingPurple = generateImageUrl('images/Module8Images/DailyReward_DinoFlying_Purple.png');
  const Volcano = generateImageUrl('images/newDesign/Unit2Module8/BigRewardVolcanoNoSmoke.png');
  const TRex = generateImageUrl('images/Module8Images/BigReward_TRex@2x.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const SingingTimeIcon = generateImageUrl('images/Module1Images/Button_SingingTime.png');
  const AfterCelebrateVideo9 = 'fb4cd2605eeba0bac77a902210b7/480.m3u8';
  const present = generateImageUrl('images/Images/Gift.png');

  const [reviewIcon, setReviewIcon] = useState(false);
  const [keyIcon, setKeyIcon] = useState(false);
  const [coinIcon, setCoinIcon] = useState(false);
  const [presentIcon, setPresentIcon] = useState(false);
  const [rewardOption1, setRewardOption1] = useState(null);
  const [rewardOption2, setRewardOption2] = useState(null);
  const [displayReward, setDisplayReward] = useState(false);

  const [displayLearn, setDisplayLearn] = useState(false);
  const [displayPractice, setDisplayPractice] = useState(false);
  const [displayDay4Practice, setDisplayDay4Practice] = useState(false);
  const [displaySingingTime, setDisplaySingingTime] = useState(false);
  const [displayCelebrate, setDisplayCelebrate] = useState(false);
  const [displaybody, setDisplayBody] = useState(true);
  const [displayGreenButton, setDisplayGreenButton] = useState(false);
  const [learn, setLearn] = useState('');
  const [day4Practice, setDay4Practice] = useState('');
  const [singTime, setSingTime] = useState('');
  const [celebrate, setCelebrate] = useState('');
  const firstUpdate = useRef(true);
  const coinUpdate = useRef(true);
  const [displayIntroVideo, setDisplayIntroVideo] = useState(false);
  const [introVideo, setIntroVideo] = useState('');
  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseVideo, setSurpriseVideo] = useState('');
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [prize, setPrize] = useState(false);
  const [displayPrize, setDisplayPrize] = useState(false);
  const [userInteracted, setUserInteracted] = useState(false);

  const keys5 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];
  const keys4 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];

  const [touchButton, setTouchButton] = useState(false);
  const [checkSound, setCheckSound] = useState(false);
  const [buttonSound, setButtonSound] = useState(false);
  const [rewardsFound, setRewardsFound] = useState(false);
  const [coinAnimationState, setCoinAnimationState] = useState('bounceIcons');
  const [coinAudio, setCoinAudio] = useState(false);

  const [specialMessage, setSpecialMessage] = useState('');
  const [watchConversation, setWatchConversation] = useState('');
  const [amazingJob, setAmazingJob] = useState('');

  const [practiceIntro, setPracticeIntro] = useState('');
  const [learnIntro, setLearnIntro] = useState('');
  const [ftbIntro, setFtbIntro] = useState('');
  const [celebrateIntro, setCelebrateIntro] = useState('');
  const [checkStep, setCheckStep] = useState('');
  const [rewardAnimationState, setRewardAnimationState] = useState('');
  const [showAnimal, setShowAnimal] = useState(false);
  const [animalState, setAnimalState] = useState('');
  const [showReward, setShowReward] = useState(false);

  const [ftbMusic, setFTBMusic] = useState('');
  const [ftbInstruction, setFTBInstruction] = useState('');
  const [ftbInstructionGIF, setFTBInstructionGIF] = useState('');
  const [ftbCount, setFTBCount] = useState('');
  const [ftbTutorial1, setFTBTutorial1] = useState('');
  const [ftbTutorial2, setFTBTutorial2] = useState('');
  const [ftbWT, setFTBWalkThrough] = useState('');

  const [showFly, setShowFly] = useState(false);
  const [lizardTongue, setLizardTongue] = useState('');
  const [bugSound, setBugSound] = useState(false);
  const [lizardTongueAudio, setLizardTongueAudio] = useState('');
  const [playLizardClose, setPlayLizardClose] = useState(false);
  const [animalClose, setAnimalClose] = useState('');
  const [animalCloseAudio, setAnimalCloseAudio] = useState('');
  const [displayFTB, setDisplayFTB] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [awesomeJob, setAwesomeJob] = useState('');
  const influencers = [
    login.influencerid,
    login.influencerid1,
    login.influencerid2,
    login.influencerid3,
    login.influencerid4,
  ];

  // Handle user interaction to enable audio on iOS
  const handleUserInteraction = useCallback(() => {
    setUserInteracted(true);
  }, []);

  // iOS audio compatibility function
  const playAudioWithUserInteraction = useCallback((audioRef, onPlay, onEnded) => {
    if (audioRef && audioRef.current && userInteracted) {
      const playPromise = audioRef.current.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            if (onPlay) onPlay();
          })
          .catch((error) => {
            console.log('Audio play failed:', error);
            // Fallback: try to play on next user interaction
            if (onEnded) onEnded();
          });
      }
    }
  }, [userInteracted]);

  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));

  // ==================== Audio & iOS Compatibility ====================
  // Utility function for delays
  const sleep = useCallback((ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }, []);

  const playButtonAudio = useCallback(() => {
    sleep(TIMING.BUTTON_AUDIO_DELAY).then(() => {
      setButtonSound(true);
    });
  }, []);

  // ==================== Media Loading ====================
  const getGifs = useCallback(() => {
    setAwesomeJob(getVideo('appfiles/ask/ask_awesome_job.mp3', login));

    setLizardTongue(getVideo('appfiles/expressions/lizard_fly.gif', login));

    setSpecialMessage(getVideo('appfiles/ask/ask_special_message.gif', login));

    setWatchConversation(getVideo('appfiles/ask/ask_conversation.gif', login));

    setAmazingJob(getVideo('appfiles/ask/Ask Awesome Job.gif', login));

    setPracticeIntro(getVideo('appfiles/ask/ask_practice_intro.gif', login));

    setLizardTongueAudio(getVideo('appfiles/expressions/expressions_fly_catch.mp3', login));

    setLearnIntro(getVideo('appfiles/ask/ask_learn_intro.gif', login));

    setFtbIntro(getVideo('appfiles/ask/ask_ftb_intro.gif', login));

    setCelebrateIntro(getVideo('appfiles/ask/ask_celebrate_intro.gif', login));

    setAnimalClose(getVideo('appfiles/ask/ask_closing.gif', login));

    setAnimalCloseAudio(getVideo('appfiles/ask/ask_day_finished.mp3', login));

    setFTBInstruction(getVideo('appfiles/ask/ask_ftb_instructions.mp3', login));

    setFTBInstructionGIF(getVideo('appfiles/ask/ask_lizard_ftb_instructions.gif', login));

    setFTBMusic(getVideo('appfiles/ask/FTB ask song and counting.m4a', login));

    setFTBCount(getVideo('appfiles/ask/countingLizard.gif', login));

    if (!module8.unlockedDays.day2) {
      setFTBTutorial1(getVideo('appfiles/greet/ftb_walkthrough_touch_circle.mp3', login));

      setFTBTutorial2(getVideo('appfiles/greet/ftb_walkthrough_count_touch.mp3', login));

      setFTBWalkThrough(getVideo('appfiles/ask/ftb_walkthrough_audio.mp3', login));
    }
  }, []);

  useEffect(() => {
    getGifs();
  }, [getGifs]);


  // ==================== iOS Detection ====================
  const isIOS = () => {
    return (
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  };

  useEffect(() => {
    let timer;
    if (displayVoice && isIOS()) {
      timer = setTimeout(() => {
        setAudioReady(false);
        setDisplayVoice(false);
        setShowAnimal(false);
        if (showFly) {
          setShowFly(false);
          setDisplayReward(true);
          setRewardsFound(true);
        }
      }, TIMING.IOS_VOICE_TIMEOUT);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [displayVoice, showFly]);

  // iOS audio compatibility - trigger audio playback when state changes
  useEffect(() => {
    if (coinAudio && coinAudioRef.current) {
      playAudioWithUserInteraction(
        coinAudioRef,
        null,
        () => {
          dispatch({ type: 'MODULE8_SET_COIN', payload: module8.coins + 1 });
          setCoinAudio(false);
          setCoinAnimationState('bounceIcons');
          setCoinIcon(false);
          playButtonAudio();
        }
      );
    }
  }, [coinAudio, playAudioWithUserInteraction, dispatch, module8.coins, playButtonAudio]);

  useEffect(() => {
    if (playLizardClose && playLizardCloseRef.current) {
      playAudioWithUserInteraction(
        playLizardCloseRef,
        () => setAudioReady(true),
        () => {
          setPlayLizardClose(false);
          module8.currentday === 8
            ? closeDay9Video()
            : navigate('/ask/navigation');
        }
      );
    }
  }, [playLizardClose, playAudioWithUserInteraction, module8.currentday, navigate]);

  useEffect(() => {
    if (checkSound && checkSoundRef.current) {
      playAudioWithUserInteraction(
        checkSoundRef,
        null,
        () => setCheckSound(false)
      );
    }
  }, [checkSound, playAudioWithUserInteraction]);

  useEffect(() => {
    if (rewardsFound && rewardsFoundRef.current) {
      playAudioWithUserInteraction(rewardsFoundRef);
    }
  }, [rewardsFound, playAudioWithUserInteraction]);

  useEffect(() => {
    if (touchButton && touchButtonRef.current) {
      playAudioWithUserInteraction(
        touchButtonRef,
        null,
        () => setTouchButton(false)
      );
    }
  }, [touchButton, playAudioWithUserInteraction]);

  useEffect(() => {
    if (buttonSound && buttonSoundRef.current) {
      playAudioWithUserInteraction(
        buttonSoundRef,
        null,
        () => setButtonSound(false)
      );
    }
  }, [buttonSound, playAudioWithUserInteraction]);

  useEffect(() => {
    if (prize && prizeRef.current) {
      playAudioWithUserInteraction(prizeRef);
    }
  }, [prize, playAudioWithUserInteraction]);

  useEffect(() => {
    if (presentIcon && presentIconRef.current) {
      playAudioWithUserInteraction(presentIconRef);
    }
  }, [presentIcon, playAudioWithUserInteraction]);

  const createGameDetails = useCallback(
    (flag, reward, coin) => {
      const game_detail = module8.game_details;
      if (flag) {
        const flags = { flag, lastUpdated: new Date().toJSON() };
        game_detail.moduleFlags.push(flags);
      }
      if (coin >= 0) {
        game_detail.tokens_earned = coin;
      }
      if (reward) {
        const dailyRewards = [];
        for (const key in module8.rewards) {
          if (module8.rewards[key] === true) {
            const rewards = { type: key, x_multiplier: 1, y_multiplier: 1 };
            dailyRewards.push(rewards);
          }
        }
        game_detail.dailyRewards = dailyRewards;
      }
      dispatch({ type: 'MODULE8_SET_GameDetials', payload: game_detail });
    },
    [dispatch, module8.game_details, module8.rewards]
  );

  // ==================== Database & Game Logic ====================
  const updateProgress = async () => {
    const payload = {
      body: {
        id: login.studentid,
        module: MODULE_NAME,
        day_completed: module8.currentday,
        time_completed: new Date().toDateString(),
      },
    };
    try {
      await API.put('TIR', '/v3/student/progress', payload);
    } catch (error) {
      // Progress update failed silently
    }
  };

  useEffect(() => {
    if (
      (module8.reviewIcon === true || login.grade === 'Teacher Mode') &&
      module8.sectionCompleted === SECTION_COMPLETED_THRESHOLD
    ) {
      updateProgress();
      module8.sectionCompleted = 0;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [module8.sectionCompleted, module8.reviewIcon, login.grade]);

  const updateDB = useCallback(async () => {
    const modulePayload = {
      body: {
        id: module8.moduleID,
        day_completed: module8.day_completed,
        step_completed: module8.stepCompleted,
        game_details: JSON.stringify(module8.game_details),
      },
    };

    try {
      await API.put('TIR', '/v3/student/module', modulePayload);
      if (displayGreenButton) {
        setAnimalVoice(null);
        setShowAnimal(true);
        setPlayLizardClose(true);
        setAnimalState(animalClose);
        setDisplayGreenButton(false);
        setDisplayReward(false);
      }
    } catch (error) {
      const criticalSteps = [
        STEP_COMPLETED.NOT_STARTED,
        STEP_COMPLETED.LEARN,
        STEP_COMPLETED.PRACTICE,
        STEP_COMPLETED.CELEBRATE,
        STEP_COMPLETED.FOLLOW_THE_BEAT,
      ];
      if (criticalSteps.includes(module8.stepCompleted)) {
        window.alert('Connection is lost. Please login again.');
        dispatch({ type: 'CLEAR' });
        Auth.signOut();
        navigate('/');
      }
    }

    // Update student's current module
    const studentPayload = {
      body: {
        id: login.studentid,
        current_module: MODULE_NAME,
      },
    };
    try {
      await API.put('TIR', '/v3/student', studentPayload);
    } catch (error) {
      // Student update failed silently
    }
  }, [
    module8.moduleID,
    module8.day_completed,
    module8.stepCompleted,
    module8.game_details,
    displayGreenButton,
    animalClose,
    dispatch,
    navigate,
    login.studentid,
  ]);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if(login.grade !== "Teacher Mode" && login.grade !== 'Free Play'){
        updateDB();
      }
    }
  }, [module8.stepCompleted]);

  useEffect(() => {
    if (module8.coins >= COIN_THRESHOLDS.PRIZE_UNLOCK) {
      setPrize(true);
    }
    if (coinUpdate.current) {
      coinUpdate.current = false;
    } else {
      createGameDetails(false, false, module8.coins);
      updateDB();
    }
  }, [module8.coins, createGameDetails, updateDB]);

  // ==================== UI Handlers ====================
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
    setCoinAudio(true);
  };

  // ==================== Progress & Step Management ====================
  useEffect(() => {
    if (module8.currentday <= module8.day_completed || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
        setShowReward(true)
      }
      dispatch({ type: 'MODULE8_TOGGLE_REVIEW_ICON', payload: true });
      dispatch({ type: 'MODULE8_SET_KEY', payload: 4 });
      if (module8.currentday === 4 || module8.currentday === 8) {
        dispatch({ type: 'MODULE8_SET_KEY', payload: 5 });
      }
    } else {
      if (module8.stepCompleted === checkStep) {
        setCoinIcon(true);
      }
      dispatch({ type: 'MODULE8_TOGGLE_REVIEW_ICON', payload: false });
      if (module8.currentday === 4 && module8.day_completed === 3) {
        if (module8.stepCompleted === STEP_COMPLETED.NOT_STARTED) {
          dispatch({ type: 'MODULE8_SET_KEY', payload: 0 });
        } else if (module8.stepCompleted === STEP_COMPLETED.SINGING_TIME) {
          dispatch({ type: 'MODULE8_SET_KEY', payload: 1 });
        } else if (module8.stepCompleted === STEP_COMPLETED.LEARN) {
          dispatch({ type: 'MODULE8_SET_KEY', payload: 2 });
        } else if (module8.stepCompleted === STEP_COMPLETED.PRACTICE) {
          dispatch({ type: 'MODULE8_SET_KEY', payload: 3 });
        } else if (module8.stepCompleted === STEP_COMPLETED.FOLLOW_THE_BEAT) {
          dispatch({ type: 'MODULE8_SET_KEY', payload: 4 });
        } else if (module8.stepCompleted === STEP_COMPLETED.CELEBRATE) {
          setKeyIcon(true);
          dispatch({ type: 'MODULE8_SET_KEY', payload: 5 });
        }
        playButtonAudio();
      } else {
        if (module8.stepCompleted === STEP_COMPLETED.NOT_STARTED) {
          dispatch({ type: 'MODULE8_SET_KEY', payload: 0 });
        } else if (module8.stepCompleted === STEP_COMPLETED.LEARN) {
          dispatch({ type: 'MODULE8_SET_KEY', payload: 1 });
        } else if (module8.stepCompleted === STEP_COMPLETED.PRACTICE) {
          dispatch({ type: 'MODULE8_SET_KEY', payload: 2 });
        } else if (module8.stepCompleted === STEP_COMPLETED.FOLLOW_THE_BEAT) {
          dispatch({ type: 'MODULE8_SET_KEY', payload: 3 });
        } else if (module8.stepCompleted === STEP_COMPLETED.CELEBRATE) {
          if (module8.currentday === 8 && module8.day_completed === 7) {
            dispatch({ type: 'MODULE8_SET_KEY', payload: 4 });
            setPresentIcon(true);
          } else {
            setKeyIcon(true);
            dispatch({ type: 'MODULE8_SET_KEY', payload: 4 });
          }
        } else if (module8.stepCompleted === STEP_COMPLETED.SURPRISE) {
          dispatch({ type: 'MODULE8_SET_KEY', payload: 5 });
          setKeyIcon(true);
        }
        playButtonAudio();
      }
    }
  }, [module8.stepCompleted]);

  // ==================== Reward & Prize Functions ====================
  const selectReward = () => {
    return (
      <>
        <div className='rewards'>
          <div className='circle' id='rewardItemLeft2'>
            <img
              src={rewardOption1}
              alt=''
              onClick={() => {
                handleUserInteraction();
                setTouchButton(true);
                dispatch({
                  type: `MODULE8_SET_REWARD${module8.currentday}1`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE8_SET_REWARD${module8.currentday}2`,
                  payload: false,
                });
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenButton(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight2'>
            <img
              src={rewardOption2}
              alt=''
              onClick={() => {
                handleUserInteraction();
                setTouchButton(true);
                dispatch({
                  type: `MODULE8_SET_REWARD${module8.currentday}2`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE8_SET_REWARD${module8.currentday}1`,
                  payload: false,
                });
                document.getElementById('rewardItemRight2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenButton(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                handleUserInteraction();
                setCheckSound(true);
                updateProgress();
                sleep(TIMING.ANIMATION_DELAY).then(() => {
                  createGameDetails(false, true, module8.coins);
                  if (login.grade === 'Teacher Mode' || login.grade === 'Free Play') {
                    updateDB();
                  }
                  dispatch({
                    type: `MODULE8_SET_DAY_UNLOCK${module8.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE8_SET_dayCompleted',
                    payload: module8.currentday === 8 ? 9 : module8.currentday,
                  });
                  dispatch({
                    type: 'MODULE8_SET_stepCompleted',
                    payload: STEP_COMPLETED.NOT_STARTED,
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  const openPrize = () => {
    return (
      <>
        <div className='rewards'>
          <div className='circle' id='rewardItemLeft'>
            <img
              src={Volcano}
              alt=''
              onClick={() => {
                handleUserInteraction();
                dispatch({ type: `MODULE8_SET_PRIZE1`, payload: true });
                dispatch({ type: `MODULE8_SET_PRIZE2`, payload: false });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenButton(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={TRex}
              alt=''
              onClick={() => {
                handleUserInteraction();
                dispatch({ type: `MODULE8_SET_PRIZE2`, payload: true });
                dispatch({ type: `MODULE8_SET_PRIZE1`, payload: false });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenButton(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                handleUserInteraction();
                setCheckSound(true);
                setDisplayPrize(false);
                sleep(TIMING.ANIMATION_DELAY).then(() => {
                  setDisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE8_SET_COIN',
                    payload: module8.coins - COIN_THRESHOLDS.PRIZE_UNLOCK,
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    switch (module8.currentday) {
      case 1:
        setRewardOption1(DinoGreen);
        setRewardOption2(DinoOrange);
        break;
      case 2:
        setRewardOption1(LongNeckGreen);
        setRewardOption2(LongNeckRed);
        break;
      case 3:
        setRewardOption1(Plant1);
        setRewardOption2(Plant2);
        break;
      case 4:
        setRewardOption1(Tree1);
        setRewardOption2(Tree2);
        break;
      case 5:
        setRewardOption1(DinoFlyingPurple);
        setRewardOption2(DinoFlyingGreen);
        break;
      case 6:
        setRewardOption1(StegoGreen);
        setRewardOption2(StegoBlue);
        break;
      case 7:
        setRewardOption1(EggsBlue);
        setRewardOption2(EggsGreen);
        break;
      case 8:
        setRewardOption1(RaptorLight);
        setRewardOption2(RaptorDark);
        break;
      default:
        break;
    }
  }, [
    keyIcon,
    DinoFlyingGreen,
    DinoFlyingPurple,
    DinoGreen,
    DinoOrange,
    EggsBlue,
    EggsGreen,
    LongNeckGreen,
    LongNeckRed,
    Plant1,
    Plant2,
    RaptorDark,
    RaptorLight,
    StegoBlue,
    StegoGreen,
    Tree1,
    Tree2,
    module8.currentday,
  ]);

  // ==================== Module Opening Functions ====================
  const displayReview = () => {
    if (module8.currentday === 4) {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns41'
              src={SingingTimeIcon}
              alt='singing button'
              onClick={() => {
                handleUserInteraction();
                displaySinging();
              }}
            />
            <img
              className='reviewBtns42'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                handleUserInteraction();
                openLearn();
              }}
            />
            <img
              className='reviewBtns43'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                handleUserInteraction();
                openPractice();
              }}
            />
            <img
              className='reviewBtns44'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                handleUserInteraction();
                openFTB();
              }}
            />
            <img
              className='reviewBtns45'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                handleUserInteraction();
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns1'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                handleUserInteraction();
                openLearn();
              }}
            />
            <img
              className='reviewBtns2'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                handleUserInteraction();
                openPractice();
              }}
            />
            <img
              className='reviewBtns3'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                handleUserInteraction();
                openFTB();
              }}
            />
            <img
              className='reviewBtns4'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                handleUserInteraction();
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    }
  };

  const introduction = () => {
    return (
      <div>
        <CloudfrontVideoFormat
          source={introVideo}
          back='/ask/navigation'
          background={background}
          token={login.cookie}
          ended={() => {
            // here is where you can add dispatch functions
            setDisplayIntroVideo(false);
            setDisplayBody(true);
            if (module8.currentday === 4) {
              dispatch({ type: 'MODULE8_SET_KEY', payload: 1 });
              playButtonAudio();
            }
            if (module8.day_completed === 9) {
              navigate('/ask/navigation');
            }
          }}
        />
      </div>
    );
  };

  const openLearn = async () => {
    let song = getVideo('appfiles/ask/ask_full_song_example.m4a', login);
    let video = getVideo('appfiles/ask/learn_video.mp4', login);
    switch (module8.currentday) {
      case 1:
        setLearn(
          <Learn
            video='21f522f53e4d4e6b378a45ba477d/480.m3u8'
            songVideo={video}
            closingVideo='712a9a92bbcd704e4a7250da5508/480.m3u8'
            destiny='/ask'
            song={song}
            back='/ask'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed={`${MODULE_NUM}_SET_stepCompleted`}
            module={module8}
          />
        );
        break;
      case 2:
        setLearn(
          <Learn
            video='80f73d46fa4ff6c066e0410e6b34/480.m3u8'
            songVideo={video}
            closingVideo='8c5a70b65d29d83047ee4de1501d/480.m3u8'
            destiny='/ask'
            song={song}
            back='/ask'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed={`${MODULE_NUM}_SET_stepCompleted`}
            module={module8}
          />
        );
        break;
      case 3:
        setLearn(
          <Learn
            video='6e432f7aec3e0978003da96b035e/480.m3u8'
            songVideo={video}
            closingVideo='987c4ba0e53d4ee1b8e6c6c12609/480.m3u8'
            destiny='/ask'
            song={song}
            back='/ask'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed={`${MODULE_NUM}_SET_stepCompleted`}
            module={module8}
          />
        );
        break;
      default:
        setAnimalVoice(getVideo('appfiles/ask/ask_learn_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(learnIntro);
        setShowAnimal(true);
        await GetUserVideo(`userfiles/${module8.StudentID}/ask_play_day_music.m4a`).then((data) => {
          fetch(data).then((response) => {
            GetUserVideo(`influencers/${influencers[module8.currentday-4]}/ask_affirmation.mp4`).then((influencerVideo) => {
              if (response.status === 200) {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/ask'
                    song={data}
                    back='/ask'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed={`${MODULE_NUM}_SET_stepCompleted`}
                    module={module8}
                    instrumental={getVideo('appfiles/ask/ask_full_song.m4a', login)}
                    influencerVideo={influencerVideo}
                  />
                );
              } else {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/ask'
                    song={song}
                    back='/ask'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed={`${MODULE_NUM}_SET_stepCompleted`}
                    module={module8}
                    influencerVideo={influencerVideo}
                  />
                );
              }
            });
          });
        });
        break;
    }
    setDisplayLearn(true);
  };

  const openPractice = async () => {
    const text = [
      'Ask Mrs. Johnson, "What is your favorite color?"',
      'Ask Mrs. Johnson, "What is your favorite animal?"',
      'Ask Mrs. Johnson, "What is your favorite food?"',
      'Ask Mrs. Johnson, "What is your favorite game?"',
      'Ask Mrs. Johnson, "What is your favorite thing to do outside?"',
    ];
    switch (module8.currentday) {
      case 1:
        setDisplayPractice(true);
        break;
      case 2:
        setDisplayPractice(true);
        break;
      case 3:
        setDisplayPractice(true);
        break;
      default:          
        const introVideo = 'b338cab65b6f3cb474654ad72b2b/480.m3u8';
        setAnimalVoice(getVideo('appfiles/ask/ask_practice_intro.mp3', login));
        setAnimalState(practiceIntro);
        setShowAnimal(true);
        // setDisplayVoice(true);
        let response = getVideo(`appfiles/ask/ask_response_${module8.currentday + 1}.mp4`, login);
        let voice1 = getVideo(`appfiles/ask/ask_practice_record_${module8.currentday + 1}.mp3`, login);
        let voice2 = getVideo('appfiles/ask/ask_practice_special_message.mp3', login);
        let voice3 = getVideo('appfiles/ask/ask_practice_watch_conversation.mp3', login);
        let voice4 = getVideo('appfiles/ask/ask_awesome_job.mp3', login);
        let greeting = getVideo(`appfiles/ask/ask_greeting_${module8.currentday + 1}.mp4`, login);
        let acknowledge7 = getVideo(`appfiles/ask/ask_acknowledge_${module8.currentday + 1}.mp4`, login);
        let question7 = getVideo(`appfiles/ask/ask_question_${module8.currentday + 1}.mp4`, login);
        GetUserVideo(`influencers/${influencers[module8.currentday-4]}/ask_video_message.mp4`).then((influencerVideo) => {
          GetUserVideo(`userfiles/${module8.StudentID}/greet_practice_video_${module8.currentday + 1}.mp4`).then((greetingResponse) => {
            GetUserVideo(`userfiles/${module8.StudentID}/answer_practice_video_${module8.currentday + 1}.mp4`).then((response7) => {
              setDay4Practice(
                <Day4Practice
                  bigAnimal={true}
                  module={module8}
                  celebrateVideo={introVideo}
                  response7={response7}
                  greetingResponse={greetingResponse}
                  acknowledge7={acknowledge7}
                  question7={question7}
                  animate2={specialMessage}
                  animate3={watchConversation}
                  animate4={amazingJob}
                  background={background}
                  response={response}
                  influencerVideo={influencerVideo}
                  text={text[module8.currentday - 4]}
                  voice1={voice1}
                  voice2={voice2}
                  voice3={voice3}
                  voice4={voice4}
                  name={`ask_practice_video_${module8.currentday + 1}.mp4`}
                  greeting={greeting}
                  closeVoice={voice4}
                  animal={animal}
                  setDisplayDay4Practice={setDisplayDay4Practice}
                  moduleNum={MODULE_NUM}
                  lizard={true}
                />
              );
            });
          });
        });
        setDisplayDay4Practice(true);
        break;
    }
  };

  const openFTB = async () => {
    switch (module8.currentday) {
      case 1:
        break;
      case 2:
        break;
      case 3:
        break;

      default:
        setAnimalVoice(getVideo('appfiles/ask/ask_ftb_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(ftbIntro);
        setShowAnimal(true);
        break;
    }

    setDisplayFTB(true);
  };

  const openCelebrate = async () => {
    const celebrateVideo1 = 'd16a0e5160e73a2135512dbada69/480.m3u8   ';
    const celebrateVideo2 = 'dcb7713828218fb4f34d5166a7a0/480.m3u8';
    const celebrateVideo3 = '3f58ab22b952b8397ddaf4067dd8/480.m3u8';

    switch (module8.currentday) {
      case 1:
        setCelebrate(
          <Celebrate
            module={module8}
            celebrateVideo={celebrateVideo1}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={MODULE_NUM}
          />
        );
        break;
      case 2:
        setCelebrate(
          <Celebrate
            module={module8}
            celebrateVideo={celebrateVideo2}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={MODULE_NUM}
          />
        );
        break;
      case 3:
        setCelebrate(
          <Celebrate
            module={module8}
            celebrateVideo={celebrateVideo3}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={MODULE_NUM}
          />
        );
        break;
      default:
        setAnimalVoice(getVideo('appfiles/ask/ask_celebrate_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(celebrateIntro);
        setShowAnimal(true);
        let voice1 = getVideo('appfiles/ask/ask_celebrate_record_important.mp3', login);
        let voice2 = getVideo('appfiles/ask/ask_celebrate_say_yes.mp3', login);
        let voice3 = getVideo('appfiles/ask/ask_awesome_job.mp3', login);
        await GetUserVideo(`influencers/${influencers[module8.currentday-4]}/ask_affirmation.mp4`).then((influencerVideo) => {
          setCelebrate(
            <Celebrate
              bigAnimal={true}
              module={module8}
              background={background}
              voice1={voice1}
              voice2={voice2}
              voice3={voice3}
              text={
                'Record yourself in an excited voice and say, "I am a very important person!"'
              }
              name={`ask_celebration_surprise_${
                module8.currentday + 1
              }.mp4`}
              influencerVideo={influencerVideo}
              animation={amazingJob}
              animal={animal}
              setDisplayCelebrate={setDisplayCelebrate}
              moduleNum={MODULE_NUM}
              lizard={true}
            />
          );
        })
        break;
    }
    setDisplayCelebrate(true);
  };

  const displaySinging = async () => {
    const introVideo = '295dca45397bcc7046bff988324f/480.m3u8';
    let noteVideo = getVideo('appfiles/ask/ask_student_notes.mp4', login);
    let singingMusic = getVideo('appfiles/ask/ask_full_song_example.m4a', login);
    let instrumental = getVideo('appfiles/ask/ask_full_song_instrumental.m4a', login);
    setSingTime(
      <SingingTime
        introVideo={introVideo}
        demoMusic={singingMusic}
        singingVideo={noteVideo}
        background={background}
        singingMusic={singingMusic}
        setDisplaySingingTime={setDisplaySingingTime}
        module={module8}
        moduleNum={MODULE_NUM}
        name='ask'
        instrumental={instrumental}
        instrumentalURL={'appfiles/ask/ask_full_song.m4a'}
      />
    );  
    setDisplaySingingTime(true);
  };

  const getSurprise = async () => {
    const usePhoto = [
      {
        video: `influencers/${login.influencerid}/ask_affirmation.mp4`,
      },
      {
        video: `userfiles/${module8.StudentID}/ask_celebration_surprise_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid1}/ask_affirmation.mp4`,
      },
      {
        video: 'appfiles/ask/ask_greeting_5.mp4',
      },
      {
        video: `userfiles/${module8.StudentID}/greet_practice_video_5.mp4`,
      },
      {
        video: `appfiles/ask/ask_question_5.mp4`,
      },
      {
        video: `userfiles/${module8.StudentID}/answer_practice_video_5.mp4`,
      },
      {
        video: 'appfiles/ask/ask_acknowledge_5.mp4',
      },
      {
        video: `userfiles/${module8.StudentID}/ask_practice_video_5.mp4`,
      },
      {
        video: `appfiles/ask/ask_response_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid2}/ask_video_message.mp4`,
      },
      {
        video: `influencers/${login.influencerid3}/ask_affirmation.mp4`,
      },
      {
        video: `userfiles/${module8.StudentID}/ask_celebration_surprise_9.mp4`,
      },
      {
        video: `influencers/${login.influencerid4}/ask_affirmation.mp4`,
      }
    ];

    for (let i = 0; i < usePhoto.length; i++) {
      await GetUserVideo(usePhoto[i].video, login).then((data) => {
        usePhoto[i].video = data;
      });
    }

    return usePhoto;
  };

  const playSurpriseVideo = async () => {
    await getSurprise().then((photo) => {
      setSurpriseVideo(
        <Surprise
          background={background}
          music={getVideo('appfiles/ask/ask_full_song_instrumental.m4a', login)}
          animal={animal}
          back={'/'}
          slides={photo}
          setDisplaySurprise={setDisplaySurprise}
        />
      );
    });
    setDisplaySurprise(true);
    setKeyIcon(true);
    setPresentIcon(false);
  };

  // ==================== Animation Functions ====================
  const rewardAnimation = () => {
    setRewardAnimationState('fade-out-fly');
    sleep(TIMING.KEY_ANIMATION_DELAY).then(() => {
      flyAnimation();
    });
  };

  const flyAnimation = () => {
    setShowFly(true);
    setAnimalState(lizardTongue);
    setAnimalVoice(lizardTongueAudio);
    setShowAnimal(true);
    setKeyIcon(false);
  };

  const closeDay9Video = () => {
    setDisplayIntroVideo(true);
    setDisplayBody(false);
    setIntroVideo(AfterCelebrateVideo9);
    setShowAnimal(false);
  };

  return (
    <>
      {coinAudio && (
        <audio
          ref={coinAudioRef}
          onEnded={() => {
            dispatch({ type: 'MODULE8_SET_COIN', payload: module8.coins + 1 });
            setCoinAudio(false);
            setCoinAnimationState('bounceIcons');
            setCoinIcon(false);
            playButtonAudio();
          }}
        >
          <source
            src={
              generateImageUrl('media/Module5Videos/earn_token.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {playLizardClose && (
        <audio
          ref={playLizardCloseRef}
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setPlayLizardClose(false);
            module8.currentday === 8
              ? closeDay9Video()
              : navigate('/ask/navigation');
          }}
        >
          <source src={animalCloseAudio} type='audio/mp3' />
        </audio>
      )}

      {checkSound && (
        <audio
          ref={checkSoundRef}
          onEnded={() => {
            setCheckSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_accept_item.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {rewardsFound && (
        <audio ref={rewardsFoundRef}>
          <source
            src={
              generateImageUrl('media/Module2Videos/daily_rewards_present.mp3')
            }
          ></source>
        </audio>
      )}
      {touchButton && (
        <audio
          ref={touchButtonRef}
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/touch_button.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {buttonSound && (
        <audio
          ref={buttonSoundRef}
          onEnded={() => {
            setButtonSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_bouncing.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {displayVoice && (
        <audio
          ref={displayVoiceRef}
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayVoice(false);
            setShowAnimal(false);
            if (showFly) {
              setShowFly(false);
              setDisplayReward(true);
              setRewardsFound(true);
            }
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
      {displayIntroVideo && introduction()}
      {!showAnimal && displayLearn && learn}
      {!showAnimal && displayDay4Practice && day4Practice}
      {displayPractice && (
        <Practice
          world2={true}
          setDisplayPractice={setDisplayPractice}
          background={background}
          stepComplete={`${MODULE_NUM}_SET_stepCompleted`}
          module={module8}
        />
      )}
      {!showAnimal && displayFTB && (
        <FollowTheBeatModule8
          setDisplayFTB={setDisplayFTB}
          awesomeJob={awesomeJob}
          awesomeJobGIF={amazingJob}
          instruction={ftbInstruction}
          instructionGIF={ftbInstructionGIF}
          song={ftbMusic}
          count={ftbCount}
          tutorial1={ftbTutorial1}
          tutorial2={ftbTutorial2}
          walkthrough={ftbWT}
          stepComplete={`${MODULE_NUM}_SET_stepCompleted`}
          module={module8}
          score={'ftb_ask'}
        />
      )}
      {displaySingingTime && singTime}
      {!showAnimal && displayCelebrate && celebrate}
      {displaySurprise && surpriseVideo}
      {((displaybody &&
        !displayLearn &&
        !displayPractice &&
        !displaySingingTime &&
        !displayCelebrate &&
        !displaySurprise &&
        !displayFTB &&
        !displayDay4Practice) ||
        showAnimal) && (
        <div
          className='askWorldBody'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module8Images/Module8NavImages/Background_JourneyMap_Unit2_Mod3.png')
            })`,
          }}
          onClick={handleUserInteraction}
          onTouchStart={handleUserInteraction}
        >
          <div className='navigation'>
            <img
              className='logoutBtn'
              src={logoutBtn}
              alt='Logout Button'
              onClick={(e) => {
                handleUserInteraction();
                togglePopup();
              }}
            />
            <img
              className='JourneyBlueImage'
              src={journeyImage}
              alt='Navigation blue world'
              onClick={() => {
                handleUserInteraction();
                navigate('/ask/navigation');
              }}
            />
          </div>
          {isOpen && (
            <PopUp
              content={
                <>
                  <b id='title'>
                    Are you sure you want to leave?
                    <br />
                  </b>
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={() => {
                      navigate('/');
                      userHasAuthenticated(false);
                      localStorage.setItem('token', 'false');
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={togglePopup}
                  >
                    NO
                  </button>
                </>
              }
              handleClose={togglePopup}
            />
          )}

          {prize && (
            <audio ref={prizeRef}>
              <source src={presentSound}></source>
            </audio>
          )}

          {prize && (
            <img
              className='prize'
              src={
                generateImageUrl('images/Images/prize.png')
              }
              alt='Logout Button'
              onClick={() => {
                handleUserInteraction();
                setPrize(false);
                rewardAnimation();
                sleep(TIMING.PRIZE_ANIMATION_DELAY).then(() => {
                  sleep(TIMING.PRIZE_DISPLAY_DELAY).then(() => {
                    setDisplayPrize(true);
                  });
                });
              }}
            />
          )}
          {prize && (
            <button
              className='prize-button'
              onClick={() => {
                handleUserInteraction();
                setPrize(false);
                setDisplayPrize(true);
              }}
            >
              {' '}
              <h5>Click Here</h5>
            </button>
          )}
          {displayPrize && openPrize()}

          <img className='lizard' src={animal} alt='lizard Icon' />
          {showAnimal && !audioReady && (
            <img alt='' id='loading' src={loading} />
          )}
          {showAnimal && (
            <img
              className={
                animalState === lizardTongue ? 'lizardTongue' : 'animatedLizard'
              }
              style={audioReady ? {} : { display: 'none' }}
              src={animalState}
              onLoad={() => setDisplayVoice(true)}
              onError={() => setShowAnimal(false)}
            />
          )}

          <div className='scoreBar'>
            <img
              className='scoreKey'
              src={coinBar}
              alt='crab Icon'
            />
            {module8.coins < COIN_THRESHOLDS.TWO_DIGIT && (
              <h5 className='scoretext1'>{module8.coins}</h5>
            )}
            {module8.coins >= COIN_THRESHOLDS.TWO_DIGIT && module8.coins < COIN_THRESHOLDS.THREE_DIGIT && (
              <h5 className='scoretext10'>{module8.coins}</h5>
            )}
            {module8.coins >= COIN_THRESHOLDS.THREE_DIGIT && (
              <h5 className='scoretext100'>{module8.coins}</h5>
            )}
            <p className='scoretext'>{COIN_THRESHOLDS.PRIZE_UNLOCK}</p>
          </div>

          {module8.currentday === 4 || module8.currentday === 8 ? (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys5[module8.keys]}
                alt='crab Icon'
              />
              <h3 className='progresstext3'>{module8.keys}/5</h3>
            </div>
          ) : (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys4[module8.keys]}
                alt='crab Icon'
              />
              <h3 className='progresstext3'>{module8.keys}/4</h3>
            </div>
          )}

          {!showAnimal && !module8.reviewIcon && !coinIcon && !displayPrize && (
            <div className='actionBtnDiv'>
              {module8.currentday === 4 &&
                module8.stepCompleted === STEP_COMPLETED.NOT_STARTED && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={SingingTimeIcon}
                    alt='learn button'
                    onClick={() => {
                      handleUserInteraction();
                      setTouchButton(true);
                      sleep(TIMING.ANIMATION_DELAY).then(() => {
                        displaySinging();
                        setCheckStep(STEP_COMPLETED.SINGING_TIME);
                      });
                    }}
                  />
                )}
              {module8.currentday !== 4 &&
                module8.stepCompleted === STEP_COMPLETED.NOT_STARTED && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={learnBtn}
                    alt='learn button'
                    onClick={() => {
                      handleUserInteraction();
                      setTouchButton(true);
                      sleep(TIMING.ANIMATION_DELAY).then(() => {
                        openLearn();
                        setCheckStep(STEP_COMPLETED.LEARN);
                      });
                    }}
                  />
                )}

              {module8.stepCompleted === STEP_COMPLETED.LEARN && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={practiceBtn}
                  alt='practice button'
                  onClick={() => {
                    handleUserInteraction();
                    touchSound.play();
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openPractice();
                      setCheckStep(STEP_COMPLETED.PRACTICE);
                    });
                  }}
                />
              )}
              {module8.stepCompleted === STEP_COMPLETED.PRACTICE && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={ftbBtn}
                  alt='celebrate button'
                  onClick={() => {
                    handleUserInteraction();
                    setTouchButton(true);
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openFTB();
                      setCheckStep(STEP_COMPLETED.FOLLOW_THE_BEAT);
                    });
                  }}
                />
              )}
              {module8.stepCompleted === STEP_COMPLETED.FOLLOW_THE_BEAT && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={celebrateBtn}
                  alt='celebrate button'
                  onClick={() => {
                    handleUserInteraction();
                    setTouchButton(true);
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openCelebrate();
                      setCheckStep(STEP_COMPLETED.CELEBRATE);
                    });
                  }}
                />
              )}
              {module8.stepCompleted === STEP_COMPLETED.SINGING_TIME && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={learnBtn}
                  alt='singing button'
                  onClick={() => {
                    handleUserInteraction();
                    setTouchButton(true);
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openLearn();
                      setCheckStep(STEP_COMPLETED.LEARN);
                    });
                  }}
                />
              )}
            </div>
          )}

          {!displayVoice && coinIcon && !displayPrize && (
            <div className='actionBtnDiv'>
              {module8.reviewIcon === false && (
                <img
                  className='chooseReward'
                  id={coinAnimationState}
                  src={coinPick}
                  alt='reward key'
                  style={{
                    position: 'absolute',
                    top: '50vh',
                    left: '50vw',
                    width: '100px',
                    height: '100px',
                    marginLeft: '-50px',
                    marginTop: '-50px',
                  }}
                  onClick={() => {
                    handleUserInteraction();
                    coinAnimation();
                  }}
                />
              )}
            </div>
          )}

          {!displayPrize &&
            !showAnimal &&
            !displayReward && (
              <div className='actionBtnDiv'>
                {module8.reviewIcon && (
                <img
                  className={showReward ? 'actionBtn3' : 'actionBtn2'}
                  src={reviewBtn}
                  alt='review button'
                  onClick={() => {
                    handleUserInteraction();
                    setReviewIcon(!reviewIcon);
                  }}
                />)}
                {showReward && (
                  <img
                    src={rewardBtn}
                    className='actionBtn4'
                    alt='review button'
                    onClick={() => {
                      handleUserInteraction();
                      setTouchButton(true);
                      rewardAnimation();
                    }}
                />)}
                {module8.reviewIcon && reviewIcon && displayReview()}
              </div>
            )}

          {!coinIcon && keyIcon && !displayPrize && (
            <img
              style={{ width: '80px', height: '75px' }}
              className='rewardsIcon'
              id={rewardAnimationState}
              src={fly}
              alt='reward key'
              onClick={() => {
                handleUserInteraction();
                rewardAnimation();
              }}
            />
          )}
          {showFly && audioReady && (
            <div id='flyY'>
              <img
                alt=''
                style={{ width: '80px', height: '75px' }}
                className='flyPosition'
                id={'flyX'}
                src={fly}
              />
            </div>
          )}
          {displayReward && selectReward()}

          {!displayPrize && !coinIcon && presentIcon && (
            <img
              className='present'
              style={{
                width: '84px',
                height: '100px',
                marginLeft: '-42px',
                zIndex: 10,
              }}
              id='bounceIcons'
              src={present}
              alt='gift'
              onClick={() => {
                handleUserInteraction();
                playSurpriseVideo();
              }}
            />
          )}
          {!displayPrize && !coinIcon && presentIcon && (
            <audio ref={presentIconRef}>
              <source src={presentSound}></source>
            </audio>
          )}

          {module8.rewards.Tree2 && (
            <img className='Tree2' src={Tree2} alt='' />
          )}
          {module8.rewards.Tree1 && (
            <img className='Tree1' src={Tree1} alt='' />
          )}
          {module8.rewards.StegoBlue && (
            <img className='StegoBlue' src={StegoBlue} alt='' />
          )}
          {module8.rewards.LongNeckGreen && (
            <img className='LongNeckGreen' src={LongNeckGreen} alt='' />
          )}
          {module8.rewards.LongNeckRed && (
            <img className='LongNeckRed' src={LongNeckRed} alt='' />
          )}
          {module8.rewards.RaptorLight && (
            <img className='RaptorLight' src={RaptorLight} alt='' />
          )}
          {module8.rewards.StegoGreen && (
            <img className='StegoGreen' src={StegoGreen} alt='' />
          )}
          {module8.rewards.EggsGreen && (
            <img className='EggsGreen' src={EggsGreen} alt='' />
          )}
          {module8.rewards.DinoFlyingGreen && (
            <img className='DinoFlyingGreen' src={DinoFlyingGreen} alt='' />
          )}
          {module8.rewards.RaptorDark && (
            <img className='RaptorDark' src={RaptorDark} alt='' />
          )}
          {module8.rewards.EggsBlue && (
            <img className='EggsBlue' src={EggsBlue} alt='' />
          )}
          {module8.rewards.DinoOrange && (
            <img className='DinoOrange' src={DinoOrange} alt='' />
          )}
          {module8.rewards.DinoGreen && (
            <img className='DinoGreen' src={DinoGreen} alt='' />
          )}
          {module8.rewards.Plant1 && (
            <img className='Plant1' src={Plant1} alt='' />
          )}
          {module8.rewards.Plant2 && (
            <img className='Plant2' src={Plant2} alt='' />
          )}
          {module8.rewards.DinoFlyingPurple && (
            <img className='DinoFlyingPurple' src={DinoFlyingPurple} alt='' />
          )}
          {module8.rewards.Volcano && (
            <img className='Volcano' src={Volcano} alt='' />
          )}
          {module8.rewards.TRex && (
            <img className='TRex' src={TRex} alt='' />
          )}
        </div>
      )}
    </>
  );
};
export default Module8World;
